module.exports = ":host{display:flex;justify-content:start}.message{margin-top:2rem}.checkbox-size{min-width:22px}\n"